import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useApp } from '../context/AppContext';
import './Sidebar.css';
import useAuth from '../hooks/useAuth';
import ChangePassword from './ChangePassword';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useApp();
  const [showMenu, setShowMenu] = React.useState(false);
  const [showChangePassword, setShowChangePassword] = React.useState(false);

  useAuth();
  
  const handleHomeClick = () => {
    navigate('/home');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div 
      className="sidebar" 
      style={{ backgroundColor: '#2c3e50', color: 'white' }}
    >
      <div className="logo">
        <img src="/assets/homeassets/Home_logo-03.svg" alt="COLA Logo" />
      </div>
      
      <div className="nav-options">
        <div 
          className={`nav-option ${location.pathname === '/home' ? 'active' : ''}`} 
          onClick={handleHomeClick}
        >
          Home
        </div>
        <div className="nav-option">
          History
        </div>
        <div className="nav-option">
          Settings
        </div>
        <div className="nav-option">
          Help
        </div>
      </div>
      
      <div className="profile-section">
        <div className="profile-option" onClick={() => setShowMenu(!showMenu)}>
          <span>My Profile</span>
        </div>
        {showMenu && (
          <div className="profile-menu-dropdown">
            <div className="menu-item" onClick={() => setShowChangePassword(true)}>
              Change Password
            </div>
            <div className="menu-item" onClick={handleLogout}>
              Logout
            </div>
          </div>
        )}
      </div>
      {showChangePassword && (
        <ChangePassword onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  );
};

export default Sidebar;
